import { useEffect, useState } from "react";
import { Check, EyeOff, Trash2, Plus } from "lucide-react";
import { toast } from "sonner";
import { SimplePage } from "@/components/SimplePage";
import { adminTestimonials, adminAddTestimonial, adminSetStatus, adminDelete } from "@/lib/testimonials";
import { errorText } from "@/lib/family";

const Row = ({ t, onChange }) => {
  const act = (fn) => async () => { try { await fn(); onChange(); } catch (e) { toast.error(errorText(e)); } };
  return (
    <li className="pp-card" data-testid={`admin-testimonial-${t.id}`}>
      <span className={`pp-badge text-xs pp-status-${t.status}`} data-testid={`admin-testimonial-status-${t.id}`}>{t.status}</span>
      <p className="mt-2">“{t.quote}”</p>
      <p className="text-sm font-bold mt-1">— {t.display_name}</p>
      <div className="flex flex-wrap gap-2 mt-3">
        {t.status !== "approved" && <button className="pp-ghost" onClick={act(() => adminSetStatus(t.id, "approved"))} data-testid={`admin-approve-${t.id}`}><Check className="h-4 w-4" /> Show on site</button>}
        {t.status === "approved" && <button className="pp-ghost" onClick={act(() => adminSetStatus(t.id, "hidden"))} data-testid={`admin-hide-${t.id}`}><EyeOff className="h-4 w-4" /> Hide</button>}
        <button className="pp-ghost" onClick={act(() => window.confirm("Delete this quote?") && adminDelete(t.id))} data-testid={`admin-delete-${t.id}`}><Trash2 className="h-4 w-4" /> Delete</button>
      </div>
    </li>
  );
};

export default function AdminTestimonials() {
  const [items, setItems] = useState(null);
  const [quote, setQuote] = useState("");
  const [name, setName] = useState("");
  const load = () => adminTestimonials().then(setItems).catch((e) => { toast.error(errorText(e)); setItems([]); });
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    try { await adminAddTestimonial({ quote: quote.trim(), display_name: name.trim(), status: "approved" }); setQuote(""); setName(""); load(); toast.success("Quote added to the site"); }
    catch (err) { toast.error(errorText(err)); }
  };

  return (
    <SimplePage testId="admin-testimonials-page" back="/account" backLabel="Account">
      <p className="pp-label">Owner tools</p>
      <h1 className="pp-h1">What parents say</h1>
      <p className="pp-sub max-w-xl">Only quotes marked "Show on site" appear on the sign-in and About pages. The section stays hidden until at least one is shown.</p>
      <form onSubmit={add} className="pp-card max-w-lg mt-6 grid gap-2" data-testid="admin-add-form">
        <p className="pp-label">Add a quote you received</p>
        <textarea className="pp-textarea" rows={3} maxLength={500} value={quote} onChange={(e) => setQuote(e.target.value)} placeholder="Quote" data-testid="admin-add-quote" />
        <input className="pp-input" style={{ marginTop: 8 }} maxLength={60} value={name} onChange={(e) => setName(e.target.value)} placeholder="Name shown, e.g. Parent of a 7-year-old" data-testid="admin-add-name" />
        <button className="pp-primary w-fit mt-2" disabled={quote.trim().length < 10 || !name.trim()} data-testid="admin-add-submit"><Plus className="h-5 w-5" /> Add & show</button>
      </form>
      <ul className="grid gap-3 mt-8 max-w-2xl" data-testid="admin-testimonial-list">
        {items?.length === 0 && <p className="pp-sub">No quotes yet.</p>}
        {items?.map((t) => <Row key={t.id} t={t} onChange={load} />)}
      </ul>
    </SimplePage>
  );
}
